// extracted by mini-css-extract-plugin
module.exports = {"container":"loadingOverlay_container__239_W","message":"loadingOverlay_message__10kWw","icon":"loadingOverlay_icon__2lbNJ undefined"};